interface HistorySession {
  id: string;
  title: string;
  updated_at: string;
}

export function historyTitle(title: string): string {
  return title.trim() || '未命名会话';
}

function dateOf(value: string): Date | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

// Compare local calendar dates without depending on the length of a DST day.
function dayIndex(date: Date): number {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;
}

function groupLabel(date: Date | null, now: Date): string {
  if (!date) return '时间未知';
  const days = dayIndex(now) - dayIndex(date);
  if (days === 0) return '今天';
  if (days === 1) return '昨天';
  if (days > 1 && days < 7) return '过去 7 天';
  return `${date.getFullYear()}年${date.getMonth() + 1}月`;
}

export function historyTime(value: string, now = new Date()): string {
  const date = dateOf(value);
  if (!date) return '更新时间未知';
  const clock = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  const days = dayIndex(now) - dayIndex(date);
  if (days === 0) return clock;
  if (days === 1) return `昨天 ${clock}`;
  const year = date.getFullYear() === now.getFullYear() ? '' : `${date.getFullYear()}年`;
  return `${year}${date.getMonth() + 1}月${date.getDate()}日 ${clock}`;
}

export function groupHistory<T extends HistorySession>(items: T[], query = '', now = new Date()): { label: string; items: T[] }[] {
  const normalize = (value: string) => value.normalize('NFKC').toLocaleLowerCase();
  const keyword = normalize(query.trim());
  const groups = new Map<string, T[]>();
  const sorted = [...items].sort((a, b) => (dateOf(b.updated_at)?.getTime() ?? -Infinity) - (dateOf(a.updated_at)?.getTime() ?? -Infinity));
  for (const item of sorted) {
    if (keyword && !normalize(historyTitle(item.title)).includes(keyword)) continue;
    const label = groupLabel(dateOf(item.updated_at), now);
    const group = groups.get(label) ?? [];
    group.push(item);
    groups.set(label, group);
  }
  return Array.from(groups, ([label, entries]) => ({ label, items: entries }));
}
